import { cn } from "@/lib/utils";

/**
 * Shared confidence indicator (5 dots, filled = confidence_dots). Extracted out of
 * Step4Review.tsx (PROJECT-077) so ManualEntityResolvePanel can reuse the same
 * visual language for AI web-search candidates instead of a second copy.
 */
export function ConfidenceDots({ filled, total = 5 }: { filled: number; total?: number }) {
  return (
    <div className="flex gap-1 items-center" title={`Confidence: ${filled}/${total}`}>
      {Array.from({ length: total }).map((_, i) => (
        <span
          key={i}
          className={cn(
            "inline-block h-1.5 w-1.5 rounded-full transition-colors",
            i < filled ? "bg-blue-500" : "bg-muted/60"
          )}
        />
      ))}
    </div>
  );
}
